import React, { Suspense, useRef, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Stack } from '@mui/material';
import InlineFiltersProvider from 'contexts/InlineFilters.context';
import CascadingFiltersView from 'views/CascadingFiltersView/CascadingFiltersView';
import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner';
import Chatbot from 'components/Chatbot/Chatbot';

const VehicleInventory = () => {
  const cascadingFiltersLocalRef = useRef([]);
  const [isShowCascadingFilters, setIsShowCascadingFilters] = useState(false);
  const [page, setPage] = useState(0);

  return (
    <InlineFiltersProvider>
      <Stack direction="row" gap={2} m={3} mr={0}>
        <Suspense fallback={<LoadingSpinner fullScreen />}>
          <Outlet context={{ page, setPage, isShowCascadingFilters, setIsShowCascadingFilters }} />
        </Suspense>
        {isShowCascadingFilters && (
          // TODO: need to find a cleaner way for this...
          <Box mt={-3} ml={-3}>
            <CascadingFiltersView
              cascadingFiltersLocalRef={cascadingFiltersLocalRef}
              setPage={setPage}
            />
          </Box>
        )}
        <Chatbot />
      </Stack>
    </InlineFiltersProvider>
  );
};

export default VehicleInventory;
